import {
  getCanonicalKanbanVisiblePropertyIds,
  KANBAN_DEFAULT_VISIBLE_BODY_PROPERTY_COUNT,
  KANBAN_DEFAULT_VISIBLE_SYSTEM_BODY_PROPERTY_TYPES,
  KANBAN_SYSTEM_BODY_PROPERTY_TYPES,
  orderCanonicalKanbanProperties,
} from '@streamlain/database-identity/database-view-defaults';

import type { DataSource } from '../../core/data-source/base.js';

export {
  KANBAN_DEFAULT_VISIBLE_BODY_PROPERTY_COUNT,
  KANBAN_DEFAULT_VISIBLE_SYSTEM_BODY_PROPERTY_TYPES,
  KANBAN_SYSTEM_BODY_PROPERTY_TYPES,
};

export function isKanbanSystemBodyProperty(
  dataSource: DataSource,
  propertyId: string
): boolean {
  const propertyType = dataSource.propertyTypeGet(propertyId);
  return !!propertyType && KANBAN_SYSTEM_BODY_PROPERTY_TYPES.has(propertyType);
}

export function orderKanbanPropertyIdsForDefault(
  dataSource: DataSource,
  propertyIds: readonly string[]
): string[] {
  return orderCanonicalKanbanProperties(
    propertyIds.map(id => ({
      id,
      type: dataSource.propertyTypeGet(id) ?? '',
    }))
  ).map(property => property.id);
}

export function getDefaultVisibleKanbanBodyPropertyIds(
  dataSource: DataSource,
  orderedPropertyIds: readonly string[]
): Set<string> {
  const visibleIds = getCanonicalKanbanVisiblePropertyIds(
    orderedPropertyIds.map(id => ({
      id,
      type: dataSource.propertyTypeGet(id) ?? '',
    }))
  );
  return new Set(
    orderedPropertyIds.filter(
      id => dataSource.propertyTypeGet(id) !== 'title' && visibleIds.has(id)
    )
  );
}

export function shouldShowKanbanPropertyByDefault(
  dataSource: DataSource,
  propertyId: string,
  visibleBodyPropertyIds: ReadonlySet<string>
): boolean {
  const propertyType = dataSource.propertyTypeGet(propertyId);
  return (
    propertyType === 'title' ||
    visibleBodyPropertyIds.has(propertyId) ||
    (!!propertyType &&
      KANBAN_DEFAULT_VISIBLE_SYSTEM_BODY_PROPERTY_TYPES.has(propertyType))
  );
}
